import { createAuthAttemptState } from '@x3algo/shared/browser/authAttemptState'

export const authAttempts = createAuthAttemptState({
  storage: () => window.localStorage,
  eventTarget: window,
  createId: () => window.crypto.randomUUID()
})

export { authAttemptError } from '@x3algo/shared/browser/authAttemptState'
